import { render, staticRenderFns } from "./tnc.vue?vue&type=template&id=04227b7e&scoped=true&"
import script from "./tnc.vue?vue&type=script&lang=js&"
export * from "./tnc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04227b7e",
  null
  
)

export default component.exports